import { useMutation, useQueryClient } from "react-query";
import { deleteAgencyMapping } from "../../../../../actions/Utilities/AgencyMapping";
import { toast } from "../../../../../components/toastNotification";

export const useDeactivateAgencyMapping = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (ids: number[] | undefined) => deleteAgencyMapping(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetAgencyMapping"]);
        toast.fire(
          "Success",
          "Agency Mapping/s were deactivated successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Agency Mappings and Permits failed",
          "Server Error: Cannot deactivate Agency Mappings and Permits",
          "error"
        );
      },
    }
  );
  return mutate;
};
